<div class="patientconfiginfos">
    <div *ngFor="let info of patient.patientInfos" class="patientconfiginfo">
            <fa-icon [icon]="info.icon" [styles]="info.icon_style" [matTooltip]="info.tip" matTooltipPosition="above"></fa-icon>
            <span [innerHTML]="info.content"></span>
        </div>
</div>